import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

const AboutJobs = () => {
  return (
    <div className="container mx-auto px-4 py-12" data-testid="gojobs-about-page">
      <div className="max-w-4xl mx-auto space-y-12">
        <div className="text-center space-y-4">
          <h1 className="text-4xl font-bold">About & Trust GoJobs</h1>
          <p className="text-lg text-muted-foreground">
            GoJobs helps Australians find jobs and helps employers hire with confidence — with clear listings,
            verified businesses, and fair application workflows.
          </p>
        </div>

        <Card>
          <CardContent className="p-8 space-y-8">
            <section className="space-y-3">
              <h2 className="text-2xl font-bold">What is GoJobs?</h2>
              <p className="text-muted-foreground leading-relaxed">
                GoJobs is GoFella’s job marketplace where candidates can discover roles and apply in-platform,
                and employers can post job ads with flexible durations and visibility options. We focus on clarity,
                transparency, and a smoother hiring experience for both sides.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold">Trust & Verification</h2>

              <div className="space-y-4">
                <div className="flex gap-4">
                  <div className="text-3xl">✅</div>
                  <div>
                    <h3 className="font-semibold mb-1">ABN (and optional ACN)</h3>
                    <p className="text-sm text-muted-foreground">
                      Employers can show a verified ABN badge. If provided, ACN can also be displayed for additional
                      business context.
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="text-3xl">🧾</div>
                  <div>
                    <h3 className="font-semibold mb-1">Clear job ads</h3>
                    <p className="text-sm text-muted-foreground">
                      Listings include structured details like work type, location, and salary format (hourly vs yearly)
                      to help candidates compare roles quickly.
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="text-3xl">🔒</div>
                  <div>
                    <h3 className="font-semibold mb-1">Privacy-first applications</h3>
                    <p className="text-sm text-muted-foreground">
                      Candidates apply through GoFella. Employers see candidate data only through the portal and should
                      follow fair hiring practices.
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="text-3xl">⏳</div>
                  <div>
                    <h3 className="font-semibold mb-1">Deadlines & listing lifecycle</h3>
                    <p className="text-sm text-muted-foreground">
                      Job ads have clear closing dates (e.g., “Closes in 3 days”). After expiry, applications are paused
                      and the listing is no longer shown in active browse results.
                    </p>
                  </div>
                </div>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold">For Candidates</h2>
              <ul className="space-y-2 text-muted-foreground list-disc list-inside">
                <li>Create one GoFella account to apply and manage your applications.</li>
                <li>Check employer verification badges where available.</li>
                <li>Apply early — watch the “Closes in …” label on listings.</li>
                <li>Only share sensitive information once you’re confident the employer is legitimate.</li>
                <li>Report suspicious job ads or messages immediately.</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold">For Employers</h2>
              <ul className="space-y-2 text-muted-foreground list-disc list-inside">
                <li>Post job ads from the Company Portal and keep details accurate and up to date.</li>
                <li>Use ABN verification to build trust with candidates.</li>
                <li>Review applications promptly and keep candidate communications professional.</li>
                <li>Respect privacy — only contact candidates via GoFella unless you have consent to move off-platform.</li>
                <li>Use upgrades/boosts responsibly to improve visibility (not to mislead candidates).</li>
              </ul>
            </section>

            <section className="rounded-lg border bg-muted/30 p-5 space-y-2">
              <h2 className="text-lg font-semibold">Need help?</h2>
              <p className="text-sm text-muted-foreground">
                If you believe a job listing or message is unsafe or misleading, please report it. Our team may remove
                content, restrict accounts, or request additional verification when needed.
              </p>
            </section>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AboutJobs;
